module.exports = __webpack_public_path__ + "img/calendar-light.0c7bdc9c.svg";